import createReactComponent from '../createReactComponent';
export default createReactComponent('map-east', 'IconMapEast', [
  ['path', { d: 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', key: 'svg-0' }],
  ['path', { d: 'M14 9h-4v6h4', key: 'svg-1' }],
  ['path', { d: 'M10 12h2.5', key: 'svg-2' }],
]);
